import ComponentManager from '@/Management/ComponentManager';
import WireframeViewFactory from '@/Factories/ViewFactories/WireframeViewFactory';
import WireframeViewModel from '@/ViewModels/Views/WireframeViewModel';
import RADApplication from '@/Management/RADApplication';
import ReducedWireframeView from '@/Components/ReducedWireframe/ReducedWireframeView';

export default class ReducedWireframeViewFactory extends WireframeViewFactory {

    constructor(params: any) {
        super(params);
    }

    public createView(viewModel: WireframeViewModel) {
        const view = ComponentManager.getView<typeof ReducedWireframeView>('ReducedWireframe');
        return new view(viewModel, this.createRootElement('Wireframe'));
    }
}

if (RADApplication.getInstance().IsReducedView) {
    ComponentManager.setFactory('Wireframe', ReducedWireframeViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
}